import React from "react"
import { graphql, Link } from "gatsby"

import { PlusSmIcon } from "@heroicons/react/solid"

import Layout from "../components/common/layout"
import SEO from "../components/common/seo"
import FeatureList from "../components/feature/featurelist"
import FaqSection from "../components/home/FaqSection"
import { getSchemaForDirectoryIndex, HIVE_SITE } from "../utils/schema"
import { featuresIndexFaq, faqToSectionProps } from "../utils/staticPageFaq"

const FeaturesPage = ({ data }) => {
  const featureCount = data.features.totalCount
  const communityCount = data.communities.totalCount
  const faq = featuresIndexFaq({ featureCount, communityCount })
  const pageSchema = getSchemaForDirectoryIndex({
    pageUrl: `${HIVE_SITE}/features/`,
    name: "Online Community Features | Hive Index",
    description:
      "Find communities by how they work, not just what they are about. Browse features like forums, live chat, events, courses, job boards, and more.",
    faq,
    breadcrumbs: [
      { name: "Home", url: `${HIVE_SITE}/` },
      { name: "Features", url: `${HIVE_SITE}/features/` },
    ],
    listName: "Community Features",
    listItems: data.features.nodes.slice(0, 20).map((f, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: f.name,
      url: `${HIVE_SITE}/features/${f.slug}/`,
    })),
    totalCount: featureCount,
  })

  return (
    <Layout pageTitle="Online community features" enableShare={true}>
      <SEO
        title="Online Community Features | Hive Index"
        description="Find communities by how they work, not just what they are about. Browse features like forums, live chat, events, courses, job boards, and more."
        generateImage={true}
        path={"/features/"}
        schema={pageSchema}
      />

      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex items-center justify-between">
          <h2 className="pr-3 bg-white text-xl font-medium text-gray-900">
            About feature tags
          </h2>
        </div>
      </div>

      <div className="mt-2 text-gray-500">
        Find communities by how they work, not just what they are about. Every
        community on The Hive Index is tagged with features that help you
        understand the experience before you join. Use these filters to find
        communities with forums, live chat, events, newsletters, courses, job
        boards, member pairing, and more.
      </div>

      {/* <div className="relative mt-6">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div className="relative flex items-center justify-between">
        <h2 className="pr-3 bg-white text-xl font-medium text-gray-900">
          How to use these filters
        </h2>
      </div>
    </div>

    <div className="mt-2 text-gray-500">
      <ul className="list-disc pl-6 space-y-1">
        <li>Want async discussion? Start with Forum.</li>
        <li>Want real-time conversation? Try Chat.</li>
        <li>Want networking? Look for Events or Pairing.</li>
        <li>Want career opportunities? Check Jobs.</li>
        <li>Want structured learning? Browse Courses.</li>
      </ul>
    </div> */}

      <div className="relative mt-8">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex items-center justify-between">
          <h2 className="pr-3 bg-white text-xl font-medium text-gray-900 flex items-center">
            <div>All Community Features</div>
          </h2>

          <Link to="/suggest/">
            <button
              type="button"
              className="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500"
            >
              <PlusSmIcon
                className="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              <span>Suggest a feature</span>
            </button>
          </Link>
        </div>
      </div>
      <div className="mt-2">
        <FeatureList features={data.features.nodes} />
      </div>

      <FaqSection faqs={faqToSectionProps(faq)} />
    </Layout>
  )
}

export const query = graphql`
  query {
    features: allGoogleSpreadsheetSourceFeatures(
      sort: { fields: count, order: DESC }
    ) {
      totalCount
      nodes {
        slug
        name
        order
        sentenceEnding
        count
        icon
        iconActive
        prefix
      }
    }
    communities: allGoogleSpreadsheetSourceCommunities(
      filter: { removed: { ne: true }, suppress: { ne: true } }
    ) {
      totalCount
    }
  }
`

export default FeaturesPage
